const agreementToggle = (() => {
  const init = () => {
    document.querySelectorAll('[data-agreement-toggle]').forEach((btn) => {
      const text = btn.closest('.custom-checkbox').querySelector('[data-agreement-text]');

      btn.addEventListener('click', () => {
        const isCollapsed = text.classList.toggle('is-collapsed');
        btn.textContent = isCollapsed ? 'czytaj więcej' : 'czytaj mniej';
      });
    });
  };

  return { init };
})();

export { agreementToggle };
